import * as React from "react";

function SvgBrowserConfig({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M18 2.25A3.75 3.75 0 0121.75 6v12A3.75 3.75 0 0118 21.75H6A3.75 3.75 0 012.25 18V6A3.75 3.75 0 016 2.25zm2.25 6.5H3.75V18a2.25 2.25 0 002.096 2.245L6 20.25h12A2.25 2.25 0 0020.25 18V8.75zM13 16.25a.75.75 0 01.102 1.493L13 17.75h-2a.75.75 0 01-.102-1.493L11 16.25h2zm-5.554-4.853l.084.073 2 2a.75.75 0 01.073.976l-.073.084-2 2a.749.749 0 01-1.133-.976l.073-.084L7.939 14l-1.47-1.47a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073zM18 3.75H6A2.25 2.25 0 003.75 6v1.25h16.5V6a2.25 2.25 0 00-2.096-2.245L18 3.75zm-7.082.996l.104.015a.753.753 0 01.29.131l.084.073c.271.27.296.688.078.981l-.073.084a.751.751 0 01-.981.078l-.084-.073a.751.751 0 01-.078-.981l.073-.084a.752.752 0 01.483-.223l.104-.001zm-2.539 0l.104.015a.753.753 0 01.29.131l.084.073c.271.27.296.688.078.981l-.073.084a.751.751 0 01-.981.078l-.084-.073a.751.751 0 01-.078-.981l.073-.084a.752.752 0 01.483-.223l.104-.001zm-2.548-.005l.104.015a.753.753 0 01.29.131l.084.073c.271.27.296.688.078.981l-.073.084a.751.751 0 01-.981.078l-.084-.073a.751.751 0 01-.078-.981l.073-.084a.752.752 0 01.483-.223l.104-.001z"
        />
      </g>
    </svg>
  );
}

export default SvgBrowserConfig;
